import React from 'react';
import Goals from './Goals';
import ParentLayout from './ParentLayout';

export default function Layout(props) {
  return (
    <ParentLayout title="Goals Tracking / Network Health Indicators">
      {function(params) {
        return (
          <>
            <Goals params={params} />
          </>
        );
      }}
    </ParentLayout>
  );
}
